import { render } from "./PageViewTahunAjaran.vue?vue&type=template&id=55e40400"
import script from "./PageViewTahunAjaran.vue?vue&type=script&lang=js"
export * from "./PageViewTahunAjaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__